import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";

import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  resetData,
  selectData,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  fetchData,
} from "./userSlice";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import {
  createChangeHandler,
  getValueStatus,
  paramsActiveType,
  paramsMasterAll,
  paramsONOFF,
  setOptionsMaster,
  showErrorDialog,
} from "../../utility";
import { UserTable } from "./UserTable";
import { fetchBranch, selectBranch } from "../branch/branchSlice";
import { fetchParam, selectDataParam } from "../param/paramSlice";
import Select from "react-select";
import { selectUser } from "../../modules/Auth/_redux/authRedux";

export const UserPage = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const data = useSelector(selectData);
  const user = useSelector(selectUser);
  const loading = useSelector(selectLoading);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);
  const dataBranch = useSelector(selectBranch);
  const dataParam = useSelector(selectDataParam);
  // Filter
  const [code, setCode] = useState("");
  const [name, setName] = useState("");
  const [type, setType] = useState("");
  const [sync, setSync] = useState("");
  const [status, setStatus] = useState("");
  const [branch, setBranch] = useState("");
  const [ownerships, setOwnerships] = useState("");

  const [optionsType, setOptionType] = useState([]);
  const [optionsBranch, setOptionBranch] = useState([]);

  useEffect(() => {
    async function fetchMyAPI() {
      await dispatch(resetData());

      await dispatch(fetchData({ pageNo: 1, pageSize: 10 }));
      await dispatch(fetchBranch({ ...paramsMasterAll }));
      await dispatch(
        fetchParam({
          ...paramsMasterAll,
          param_group_code: "SALES_TYPE",
          is_active: true,
        })
      );
    }
    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    if (dataParam.length > 0) {
      setOptionsMaster(dataParam, setOptionType, "param_code", "param_value");
    }
  }, [dataParam]);

  useEffect(() => {
    if (user && user.list_data_ownerships.length > 0) {
      setOptionsMaster(
        user.list_data_ownerships,
        setOptionBranch,
        "branch_code",
        "branch_name"
      );
    }
  }, [user]);

  const paramsFilter = {
    company_sales_code: code,
    branch_code: branch,
    sales_type: type,
    is_active: status,
    available_direct_sync: sync,
    ownerships: ownerships,
  };

  const handleSearch = async () => {
    const params = {
      ...paramsFilter,
      pageNo: 1,
      pageSize: 10,
    };

    try {
      const response = await dispatch(fetchData(params));
      if (response.payload.data.status_code === 200) {
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleTableChange = async (
    type,
    { page, sizePerPage, sortField, sortOrder, data }
  ) => {
    if (type === "pagination") {
      const params = {
        ...paramsFilter,
        pageNo: page,
        pageSize: sizePerPage,
      };
      try {
        const response = await dispatch(fetchData(params));
        if (response.payload.data.status_code === 200) {
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
      }
    } else {
      const response = await dispatch(
        fetchData({
          ...paramsFilter,
          sort_order: sortOrder,
          sort_field: sortField,
          pageNo: 1,
          pageSize: sizePerPage,
        })
      );
      let result;
      if (sortOrder === "asc") {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return 1;
          } else if (b[sortField] > a[sortField]) {
            return -1;
          }
          return 0;
        });
      } else {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return -1;
          } else if (b[sortField] > a[sortField]) {
            return 1;
          }
          return 0;
        });
        console.log(result, "desc");
      }
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  const handleChangeType = createChangeHandler(setType);
  const handleChangeBranch = createChangeHandler(setBranch);
  const handleChangeOwnerships = createChangeHandler(setOwnerships);
  const handleChangeSynch = createChangeHandler(setSync);
  const handleChangeStatus = createChangeHandler(setStatus);

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <Card>
      <CardHeader title="User">
        <CardHeaderToolbar>
          <Button
            className="btn btn-danger"
            onClick={() => history.push("/administration/user/create")}
          >
            Create
          </Button>
        </CardHeaderToolbar>
      </CardHeader>{" "}
      <CardBody>
        {/* Filter */}
        <Form className="mb-5">
          <Form.Group as={Row}>
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Sales / Admin</b>
                </Form.Label>
                <Col sm={6}>
                  <Form.Control
                    type="text"
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                    onKeyPress={handleKeyPress}
                  />
                </Col>
              </Form.Group>

              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Ownerships</b>
                </Form.Label>
                <Col sm={6}>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    options={optionsBranch}
                    value={getValueStatus(ownerships, optionsBranch)}
                    placeholder="Select ..."
                    onChange={handleChangeOwnerships}
                    isClearable={true}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Status</b>
                </Form.Label>
                <Col sm={6}>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    options={paramsActiveType}
                    value={getValueStatus(status, paramsActiveType)}
                    placeholder="Select ..."
                    onChange={handleChangeStatus}
                    isClearable={true}
                  />
                </Col>
              </Form.Group>
            </Col>

            {/* Right Row */}

            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Type</b>
                </Form.Label>
                <Col sm={6}>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    options={optionsType}
                    value={getValueStatus(type, optionsType)}
                    placeholder="Select ..."
                    onChange={handleChangeType}
                    isClearable={true}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Direct Sync</b>
                </Form.Label>
                <Col sm={6}>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    options={paramsONOFF}
                    value={getValueStatus(sync, paramsONOFF)}
                    placeholder="Select ..."
                    onChange={handleChangeSynch}
                    isClearable={true}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Branch</b>
                </Form.Label>
                <Col sm={6}>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    options={optionsBranch}
                    value={getValueStatus(branch, optionsBranch)}
                    placeholder="Select ..."
                    onChange={handleChangeBranch}
                    isClearable={true}
                  />
                </Col>
              </Form.Group>

              <Form.Group as={Row}>
                <Col sm={3}>
                  <Button
                    className="btn btn-outline-danger"
                    onClick={handleSearch}
                  >
                    Search
                  </Button>
                </Col>
                {/* <Col sm={3}>
                  <Button
                    className="btn btn-warning"
                    onClick={() => history.push("/masterdata/vendor-create")}
                  >
                    Create
                  </Button>
                </Col> */}
              </Form.Group>
            </Col>
          </Form.Group>
        </Form>

        {/* Table */}
        <UserTable
          data={Array.isArray(data) ? data : []}
          page={pageNo}
          sizePerPage={pageSize}
          totalSize={totalRecord}
          onTableChange={handleTableChange}
          loading={loading}
        />
      </CardBody>
    </Card>
  );
};
